import React from "react";
import { connect } from "react-redux";
import { fetchMerchant } from "../../../actions/merchantActions";
import {
  earnMorePoints,
  orderOnline,
  freeProduct,
  percentageCoupon,
  freeShippingCoupon,
  giftcardIcon,
} from "../../../helpers/icons";
import { languages } from "../../../helpers/language";

const MembershipPlan = ({ merchantData, customerData, appstateData, plan }) => {
  let { merchant, currencySymbol } = merchantData;
  let { customer } = customerData;
  let { shopDomain } = appstateData;

  const details = {
    order_desc:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "earn.order_desc"
      ],
    giftcard_order_desc:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "earn.giftcard_order_desc"
      ],
    points_title:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.points_title"
      ],
    discount_desc:
      languages[merchant?.customWidgetTheme?.language || "en"]["discount.desc"],
    apply_code:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "discount.apply_code"
      ],
    membership_program_loyalty_multiplier:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "membership_program.loyalty_multiplier"
      ],
    membership_program_bonus_points:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "membership_program.bonus_points"
      ],
    membership_program_bonus_points_desc:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "membership_program.bonus_points_desc"
      ],
    membership_program_bonus_giftcard:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "membership_program.bonus_giftcard"
      ],
    membership_program_bonus_giftcard_desc:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "membership_program.bonus_giftcard_desc"
      ],
    membership_program_percentage_discount_coupon:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "membership_program.percentage_discount_coupon"
      ],
    membership_program_percentage_discount_coupon_desc:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "membership_program.percentage_discount_coupon_desc"
      ],
    membership_program_free_shipping_desc:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "membership_program.free_shipping_desc"
      ],
    membership_program_free_shipping:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "membership_program.free_shipping"
      ],
    membership_program_percentage_automatic_discount:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "membership_program.percentage_automatic_discount"
      ],
    membership_program_percentage_automatic_discount_desc:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "membership_program.percentage_automatic_discount_desc"
      ],
    membership_program_free_shipping_automatic_discount:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "membership_program.free_shipping_automatic_discount"
      ],
    membership_program_free_shipping_automatic_discount_desc:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "membership_program.free_shipping_automatic_discount_desc"
      ],
    membership_program_active_plan:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "membership_program.active_plan"
      ],
    membership_program_no_plan_benefits:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "membership_program.no_plan_benefits"
      ],
    expiry_date:
      languages[merchant?.theme?.language || "en"]["discount.expiry_date"],
  };

  let order_desc = details.order_desc;
  order_desc = order_desc.replace(
    /{value}/g,
    `${merchant?.orderPoints} * ${
      plan?.benefits?.loyaltyMultiplier?.points ?? 1
    }`
  );
  order_desc = order_desc.replace(/{currency}/g, currencySymbol);
  order_desc = order_desc.replace(
    /{points_currency}/g,
    merchant?.pointsCurrency !== "Super-Points"
      ? merchant?.pointsCurrency
      : details.points_title
  );
  order_desc = order_desc.replace(
    /{amount_spent}/g,
    merchant?.waysToEarnSettings?.orderSpentForPoints || 1
  );

  let giftcard_order_desc = details.giftcard_order_desc;
  giftcard_order_desc = giftcard_order_desc.replace(
    /{value}/g,
    `${currencySymbol}${merchant?.orderGiftcard.credit} * ${
      plan?.benefits?.loyaltyMultiplier?.giftcard ?? 1
    }`
  );
  giftcard_order_desc = giftcard_order_desc.replace(
    /{value2}/g,
    `${currencySymbol}${merchant?.orderGiftcard.spent}`
  );

  let bonus_points_desc = details.membership_program_bonus_points_desc;
  bonus_points_desc = bonus_points_desc.replace(
    /{value}/g,
    `${plan?.benefits?.bonusPoints?.value ?? 0}`
  );
  bonus_points_desc = bonus_points_desc.replace(
    /{points_currency}/g,
    merchant?.pointsCurrency !== "Super-Points"
      ? merchant?.pointsCurrency
      : details.points_title
  );

  let bonus_giftcard_desc = details.membership_program_bonus_giftcard_desc;
  bonus_giftcard_desc = bonus_giftcard_desc.replace(
    /{value}/g,
    `${currencySymbol}${plan?.benefits?.bonusGiftcard?.value ?? 0}`
  );

  let percentage_discount_coupon_desc = plan?.benefits?.percentageDiscountCoupon
    ?.automaticDiscountId
    ? details.membership_program_percentage_automatic_discount_desc
    : details.membership_program_percentage_discount_coupon_desc;
  percentage_discount_coupon_desc = percentage_discount_coupon_desc.replace(
    /{value}/g,
    `${plan?.benefits?.percentageDiscountCoupon?.percentage ?? 0}`
  );

  return (
    <div className="membershipProgram-item-container">
      {customer?.membershipPlanName === plan.title && (
        <div className="membershipProgram-active-plan-text-container">
          <span className="membershipProgram-active-plan-text">
            {details.membership_program_active_plan}
          </span>
        </div>
      )}
      <div className="membershipProgram-icon-title-container">
        <div className="membershipProgram-icon-container">
          <img src={plan?.image} alt="plan-image" />
        </div>
        <div className="membershipProgram-title-container">
          <h3>{plan?.title}</h3>
          {customer?.membershipPlanName &&
            customer?.membershipPlanName === plan?.title && (
              <div className="text-xs text-gray-500">
                {details.expiry_date} :{" "}
                {new Date(customer?.membershipWillExpire).toLocaleString(
                  "en-IN",
                  {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                  }
                )}
              </div>
            )}
        </div>
      </div>
      {plan?.benefits && (
        <div className="membershipProgram-benefits-container">
          {(merchant?.isPointsActive &&
            merchant?.waysToEarn?.order &&
            plan?.benefits?.loyaltyMultiplier?.status) ||
          (merchant.isGiftcardsActive &&
            merchant?.waysToEarnGiftcards?.order &&
            plan?.benefits?.loyaltyMultiplier?.status) ||
          (merchant?.isPointsActive && plan?.benefits?.bonusPoints?.status) ||
          plan?.benefits?.bonusGiftcard?.status ||
          plan?.benefits?.percentageDiscountCoupon?.status ||
          plan?.benefits?.freeShipping?.status ||
          plan?.benefits?.additionalBenefits?.length > 0 ? (
            <h4 className="membershipProgram-benefits-text">Benefits</h4>
          ) : (
            <span className="membershipProgram-noBenefit">
              {details.membership_program_no_plan_benefits}
            </span>
          )}

          {merchant?.isPointsActive &&
            merchant?.waysToEarn?.order &&
            plan?.benefits?.loyaltyMultiplier?.status && (
              <div className="membershipProgram-benefits-item-container">
                <img
                  className="membershipProgram-benefits-item-img"
                  src={orderOnline(merchant?.customWidgetTheme?.iconcolor)}
                  alt="item-img"
                />
                <div className="membershipProgram-benefits-item-title-desc-container">
                  <h3>{details.membership_program_loyalty_multiplier}</h3>
                  <p>{order_desc}</p>
                </div>
              </div>
            )}

          {merchant.isGiftcardsActive &&
            merchant?.waysToEarnGiftcards?.order &&
            plan?.benefits?.loyaltyMultiplier?.status && (
              <div className="membershipProgram-benefits-item-container">
                <img
                  className="membershipProgram-benefits-item-img"
                  src={orderOnline(merchant?.customWidgetTheme?.iconcolor)}
                  alt="item-img"
                />
                <div className="membershipProgram-benefits-item-title-desc-container">
                  <h3>{details.membership_program_loyalty_multiplier}</h3>
                  <p>{giftcard_order_desc}</p>
                </div>
              </div>
            )}

          {merchant?.isPointsActive && plan?.benefits?.bonusPoints?.status && (
            <div className="membershipProgram-benefits-item-container">
              <img
                className="membershipProgram-benefits-item-img"
                src={earnMorePoints(merchant?.customWidgetTheme?.iconcolor)}
                alt="item-img"
              />
              <div className="membershipProgram-benefits-item-title-desc-container">
                <h3>{details.membership_program_bonus_points}</h3>
                <p>{bonus_points_desc}</p>
              </div>
            </div>
          )}

          {plan?.benefits?.bonusGiftcard?.status && (
            <div className="membershipProgram-benefits-item-container">
              <img
                className="membershipProgram-benefits-item-img"
                src={giftcardIcon(merchant?.customWidgetTheme?.iconcolor)}
                alt="item-img"
              />
              <div className="membershipProgram-benefits-item-title-desc-container">
                <h3>{details.membership_program_bonus_giftcard}</h3>
                <p>{bonus_giftcard_desc}</p>
              </div>
            </div>
          )}

          {plan?.benefits?.percentageDiscountCoupon?.status && (
            <div className="membershipProgram-benefits-coupon-item-container">
              <div className="membershipProgram-benefits-coupon-item-img-title-container">
                <img
                  className="membershipProgram-benefits-item-img"
                  src={percentageCoupon(merchant?.customWidgetTheme?.iconcolor)}
                  alt="item-img"
                />
                <div className="membershipProgram-benefits-item-title-desc-container">
                  <h3>
                    {plan?.benefits?.percentageDiscountCoupon
                      ?.automaticDiscountId
                      ? details.membership_program_percentage_automatic_discount
                      : details.membership_program_percentage_discount_coupon}
                  </h3>
                  <p>{percentage_discount_coupon_desc}</p>
                </div>
              </div>
              {customer?.membershipPlanName &&
                customer?.membershipPlanName === plan?.title &&
                plan?.benefits?.percentageDiscountCoupon?.discountCodeId && (
                  <div className="membershipProgram-benefits-coupon-item-couponCode-container">
                    <div className="membershipProgram-benefits-coupon-item-couponCode-desc">
                      {merchant?.currentPlan?.planName !== "free" &&
                      merchant?.theme?.textCustomization?.othersText
                        ? merchant?.theme?.textCustomization.othersText
                            .useThisDiscountCode
                        : details.discount_desc}
                    </div>
                    <div
                      onClick={() =>
                        navigator.clipboard.writeText(
                          plan?.benefits?.percentageDiscountCoupon?.couponCode
                        )
                      }
                      className="membershipProgram-benefits-coupon-item-couponCode-input-btn-container"
                    >
                      <input
                        className="membershipProgram-benefits-coupon-item-couponCode-input"
                        readOnly
                        value={
                          plan?.benefits?.percentageDiscountCoupon?.couponCode
                        }
                      />
                      <button
                        onClick={() =>
                          navigator.clipboard.writeText(
                            plan?.benefits?.percentageDiscountCoupon?.couponCode
                          )
                        }
                        className="membershipProgram-benefits-coupon-item-couponCode-input-btn"
                      ></button>
                    </div>
                    {/* Apply Code btn */}
                    <div className="membershipProgram-benefits-coupon-item-couponCode-btn-container">
                      <button
                        className="membershipProgram-benefits-coupon-item-couponCode-btn"
                        onClick={() =>
                          // navigator.clipboard.writeText(currentDiscountCode.code)
                          window.open(
                            `https://${shopDomain}/discount/${plan?.benefits?.percentageDiscountCoupon?.couponCode}`,
                            "_PARENT"
                          )
                        }
                      >
                        {merchant?.currentPlan?.planName !== "free" &&
                        merchant?.theme?.textCustomization?.othersText
                          ? merchant?.theme?.textCustomization?.othersText
                              ?.applyCodeButton
                          : details.apply_code}
                      </button>
                    </div>
                  </div>
                )}
            </div>
          )}

          {plan?.benefits?.freeShipping?.status && (
            <div className="membershipProgram-benefits-coupon-item-container">
              <div className="membershipProgram-benefits-coupon-item-img-title-container">
                <img
                  className="membershipProgram-benefits-item-img"
                  src={freeShippingCoupon(
                    merchant?.customWidgetTheme?.iconcolor
                  )}
                  alt="item-img"
                />
                <div className="membershipProgram-benefits-item-title-desc-container">
                  <h3>
                    {plan?.benefits?.freeShipping?.automaticDiscountId
                      ? details.membership_program_free_shipping_automatic_discount
                      : details.membership_program_free_shipping}
                  </h3>
                  <p>
                    {plan?.benefits?.freeShipping?.automaticDiscountId
                      ? details.membership_program_free_shipping_automatic_discount_desc
                      : details.membership_program_free_shipping_desc}
                  </p>
                </div>
              </div>
              {customer?.membershipPlanName &&
                customer?.membershipPlanName === plan?.title &&
                plan?.benefits?.freeShipping?.discountCodeId && (
                  <div className="membershipProgram-benefits-coupon-item-couponCode-container">
                    <div className="membershipProgram-benefits-coupon-item-couponCode-desc">
                      {merchant?.currentPlan?.planName !== "free" &&
                      merchant?.theme?.textCustomization?.othersText
                        ? merchant?.theme?.textCustomization.othersText
                            .useThisDiscountCode
                        : details.discount_desc}
                    </div>
                    <div
                      onClick={() =>
                        navigator.clipboard.writeText(
                          plan?.benefits?.freeShipping?.couponCode
                        )
                      }
                      className="membershipProgram-benefits-coupon-item-couponCode-input-btn-container"
                    >
                      <input
                        className="membershipProgram-benefits-coupon-item-couponCode-input"
                        readOnly
                        value={plan?.benefits?.freeShipping?.couponCode}
                      />
                      <button
                        onClick={() =>
                          navigator.clipboard.writeText(
                            plan?.benefits?.freeShipping?.couponCode
                          )
                        }
                        className="membershipProgram-benefits-coupon-item-couponCode-input-btn"
                      ></button>
                    </div>
                    {/* Apply Code btn */}
                    <div className="membershipProgram-benefits-coupon-item-couponCode-btn-container">
                      <button
                        className="membershipProgram-benefits-coupon-item-couponCode-btn"
                        onClick={() =>
                          // navigator.clipboard.writeText(currentDiscountCode.code)
                          window.open(
                            `https://${shopDomain}/discount/${plan?.benefits?.freeShipping?.couponCode}`,
                            "_PARENT"
                          )
                        }
                      >
                        {merchant?.currentPlan?.planName !== "free" &&
                        merchant?.theme?.textCustomization?.othersText
                          ? merchant?.theme?.textCustomization?.othersText
                              ?.applyCodeButton
                          : details.apply_code}
                      </button>
                    </div>
                  </div>
                )}
            </div>
          )}

          {plan?.benefits?.additionalBenefits?.length > 0 &&
            plan?.benefits?.additionalBenefits?.map((benefit, i) => (
              <div
                className="membershipProgram-benefits-additional-item-container"
                key={i}
              >
                <img
                  className="membershipProgram-benefits-item-img"
                  src={freeProduct(merchant?.customWidgetTheme?.iconcolor)}
                  alt="item-img"
                />
                <div className="membershipProgram-benefits-additional-item-title-container">
                  <h3>{benefit.title}</h3>
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  merchantData: state.MerchantReducer,
  customerData: state.CustomerReducer,
  appstateData: state.AppstateReducer,
});

const mapDispatchToProps = (dispatch) => ({
  fetchMerchant: (shopDomain) => dispatch(fetchMerchant(shopDomain)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MembershipPlan);
